/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Core.UserRole
 * User role.
 */
export var CoreUserRole;
(function (CoreUserRole) {
  CoreUserRole["SUPER_ADMIN"] = "SUPER_ADMIN";
  CoreUserRole["PLATFORM_ADMIN"] = "PLATFORM_ADMIN";
  CoreUserRole["ORG_ADMIN"] = "ORG_ADMIN";
  CoreUserRole["ADMIN"] = "ADMIN";
  CoreUserRole["MANAGER"] = "MANAGER";
  CoreUserRole["OWNER"] = "OWNER";
  CoreUserRole["COLLABORATOR"] = "COLLABORATOR";
  CoreUserRole["RESTRICTED"] = "RESTRICTED";
  CoreUserRole["TENANT"] = "TENANT";
  CoreUserRole["VENDOR"] = "VENDOR";
  CoreUserRole["USER"] = "USER";
  CoreUserRole["VIEWER"] = "VIEWER";
  CoreUserRole["MAINTENANCE_COORDINATOR"] = "MAINTENANCE_COORDINATOR";
})(CoreUserRole || (CoreUserRole = {}));
/**
 * UploadStatus
 * Upload status for assets.
 */
export var UploadStatus;
(function (UploadStatus) {
  UploadStatus["PENDING"] = "PENDING";
  UploadStatus["UPLOADING"] = "UPLOADING";
  UploadStatus["COMPLETED"] = "COMPLETED";
  UploadStatus["FAILED"] = "FAILED";
  UploadStatus["EXPIRED"] = "EXPIRED";
})(UploadStatus || (UploadStatus = {}));
/**
 * TrustAccountType
 * Schema representing TrustAccountType.
 */
export var TrustAccountType;
(function (TrustAccountType) {
  TrustAccountType["TRUST"] = "TRUST";
  TrustAccountType["ESCROW"] = "ESCROW";
  TrustAccountType["OPERATING"] = "OPERATING";
})(TrustAccountType || (TrustAccountType = {}));
/**
 * TourVerificationStatus
 * Schema representing TourVerificationStatus.
 */
export var TourVerificationStatus;
(function (TourVerificationStatus) {
  TourVerificationStatus["PENDING"] = "PENDING";
  TourVerificationStatus["VERIFIED"] = "VERIFIED";
  TourVerificationStatus["REJECTED"] = "REJECTED";
})(TourVerificationStatus || (TourVerificationStatus = {}));
/**
 * TourAccessStatus
 * Schema representing TourAccessStatus.
 */
export var TourAccessStatus;
(function (TourAccessStatus) {
  TourAccessStatus["PENDING_VERIFICATION"] = "PENDING_VERIFICATION";
  TourAccessStatus["CODE_DISPATCHED"] = "CODE_DISPATCHED";
  TourAccessStatus["ACCESSED"] = "ACCESSED";
  TourAccessStatus["COMPLETED"] = "COMPLETED";
  TourAccessStatus["EXPIRED"] = "EXPIRED";
  TourAccessStatus["REVOKED"] = "REVOKED";
})(TourAccessStatus || (TourAccessStatus = {}));
/**
 * TaxStatus
 * Tax status.
 */
export var TaxStatus;
(function (TaxStatus) {
  TaxStatus["RESPONSABLE_INSCRIPTO"] = "RESPONSABLE_INSCRIPTO";
  TaxStatus["MONOTRIBUTISTA"] = "MONOTRIBUTISTA";
  TaxStatus["IVA_EXENTO"] = "IVA_EXENTO";
})(TaxStatus || (TaxStatus = {}));
/**
 * TaxDocumentType
 * Tax document type for contractor and maintenance billing.
 */
export var TaxDocumentType;
(function (TaxDocumentType) {
  TaxDocumentType["BOLETA_HONORARIOS"] = "BOLETA_HONORARIOS";
  TaxDocumentType["BOLETA_SERVICIOS"] = "BOLETA_SERVICIOS";
  TaxDocumentType["FACTURA_AFECTA"] = "FACTURA_AFECTA";
  TaxDocumentType["FACTURA_EXENTA"] = "FACTURA_EXENTA";
  TaxDocumentType["NONE"] = "NONE";
})(TaxDocumentType || (TaxDocumentType = {}));
/**
 * TaxComplianceStatus
 * Tax document compliance verification status.
 */
export var TaxComplianceStatus;
(function (TaxComplianceStatus) {
  TaxComplianceStatus["PENDING_RECEIPT"] = "PENDING_RECEIPT";
  TaxComplianceStatus["VERIFIED"] = "VERIFIED";
  TaxComplianceStatus["EXEMPT"] = "EXEMPT";
  TaxComplianceStatus["REJECTED"] = "REJECTED";
})(TaxComplianceStatus || (TaxComplianceStatus = {}));
/**
 * TaskStatus
 * Canonical task statuses.
 */
export var TaskStatus;
(function (TaskStatus) {
  TaskStatus["TODO"] = "TODO";
  TaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
  TaskStatus["BLOCKED"] = "BLOCKED";
  TaskStatus["COMPLETED"] = "COMPLETED";
  TaskStatus["CANCELLED"] = "CANCELLED";
})(TaskStatus || (TaskStatus = {}));
/**
 * TaskPriority
 * Canonical task priorities.
 */
export var TaskPriority;
(function (TaskPriority) {
  TaskPriority["LOW"] = "LOW";
  TaskPriority["MEDIUM"] = "MEDIUM";
  TaskPriority["HIGH"] = "HIGH";
  TaskPriority["URGENT"] = "URGENT";
})(TaskPriority || (TaskPriority = {}));
/**
 * SmartLockStatus
 * Schema representing SmartLockStatus.
 */
export var SmartLockStatus;
(function (SmartLockStatus) {
  SmartLockStatus["ACTIVE"] = "ACTIVE";
  SmartLockStatus["OFFLINE"] = "OFFLINE";
  SmartLockStatus["LOW_BATTERY"] = "LOW_BATTERY";
  SmartLockStatus["MAINTENANCE"] = "MAINTENANCE";
})(SmartLockStatus || (SmartLockStatus = {}));
/**
 * SmartLockProvider
 * Schema representing SmartLockProvider.
 */
export var SmartLockProvider;
(function (SmartLockProvider) {
  SmartLockProvider["RENTLY"] = "RENTLY";
  SmartLockProvider["IGLOOHOME"] = "IGLOOHOME";
  SmartLockProvider["YALE"] = "YALE";
  SmartLockProvider["AUGUST"] = "AUGUST";
  SmartLockProvider["MASTER_LOCK_VAULT"] = "MASTER_LOCK_VAULT";
  SmartLockProvider["MANUAL_CODE"] = "MANUAL_CODE";
})(SmartLockProvider || (SmartLockProvider = {}));
/**
 * SmartLockDeviceType
 * Schema representing SmartLockDeviceType.
 */
export var SmartLockDeviceType;
(function (SmartLockDeviceType) {
  SmartLockDeviceType["SMART_LOCK"] = "SMART_LOCK";
  SmartLockDeviceType["ELECTRONIC_LOCKBOX"] = "ELECTRONIC_LOCKBOX";
  SmartLockDeviceType["KEYPAD_DEADBOLT"] = "KEYPAD_DEADBOLT";
  SmartLockDeviceType["HOUMBOX"] = "HOUMBOX";
})(SmartLockDeviceType || (SmartLockDeviceType = {}));
/**
 * SmartLockAccessMode
 * Schema representing SmartLockAccessMode.
 */
export var SmartLockAccessMode;
(function (SmartLockAccessMode) {
  SmartLockAccessMode["DYNAMIC_PIN"] = "DYNAMIC_PIN";
  SmartLockAccessMode["TIME_WINDOW_CODE"] = "TIME_WINDOW_CODE";
  SmartLockAccessMode["BLUETOOTH_MOBILE_KEY"] = "BLUETOOTH_MOBILE_KEY";
})(SmartLockAccessMode || (SmartLockAccessMode = {}));
/**
 * Core.ShareResourceType
 * Resource kinds that can be targeted by a share link.
 */
export var CoreShareResourceType;
(function (CoreShareResourceType) {
  CoreShareResourceType["MAINTENANCE_PROJECT"] = "MAINTENANCE_PROJECT";
  CoreShareResourceType["MAINTENANCE_REQUEST"] = "MAINTENANCE_REQUEST";
  CoreShareResourceType["MAINTENANCE_STATEMENT"] = "MAINTENANCE_STATEMENT";
  CoreShareResourceType["RENTAL_CONTRACT"] = "RENTAL_CONTRACT";
  CoreShareResourceType["EVENT_TYPE"] = "EVENT_TYPE";
  CoreShareResourceType["DATABASE_FORM"] = "DATABASE_FORM";
})(CoreShareResourceType || (CoreShareResourceType = {}));
/**
 * Core.ShareLinkPermission
 * Permission granted to the bearer of a share link.
 */
export var CoreShareLinkPermission;
(function (CoreShareLinkPermission) {
  CoreShareLinkPermission["READ"] = "READ";
  CoreShareLinkPermission["COMMENT"] = "COMMENT";
  CoreShareLinkPermission["WRITE"] = "WRITE";
  CoreShareLinkPermission["MANAGE"] = "MANAGE";
  CoreShareLinkPermission["AVAILABILITY_EDITOR"] = "AVAILABILITY_EDITOR";
})(CoreShareLinkPermission || (CoreShareLinkPermission = {}));
/**
 * RiskGrade
 * Assessed partner risk grade.
 */
export var RiskGrade;
(function (RiskGrade) {
  RiskGrade["LOW_RISK"] = "LOW_RISK";
  RiskGrade["MEDIUM_RISK"] = "MEDIUM_RISK";
  RiskGrade["HIGH_RISK"] = "HIGH_RISK";
})(RiskGrade || (RiskGrade = {}));
/**
 * Rentals.RentalStatus
 * Rental status.
 */
export var RentalsRentalStatus;
(function (RentalsRentalStatus) {
  RentalsRentalStatus["DRAFT"] = "DRAFT";
  RentalsRentalStatus["PENDING_SIGNATURE"] = "PENDING_SIGNATURE";
  RentalsRentalStatus["ACTIVE"] = "ACTIVE";
  RentalsRentalStatus["EXPIRED"] = "EXPIRED";
  RentalsRentalStatus["TERMINATED"] = "TERMINATED";
  RentalsRentalStatus["RENEWED"] = "RENEWED";
  RentalsRentalStatus["LEGAL_DEFAULT"] = "LEGAL_DEFAULT";
  RentalsRentalStatus["DEFAULT_NOTICE_ISSUED"] = "DEFAULT_NOTICE_ISSUED";
})(RentalsRentalStatus || (RentalsRentalStatus = {}));
/**
 * RentalPaymentLineItemType
 * Type of a rental payment line item.
 */
export var RentalPaymentLineItemType;
(function (RentalPaymentLineItemType) {
  RentalPaymentLineItemType["RENT"] = "RENT";
  RentalPaymentLineItemType["GASTOS_COMUNES"] = "GASTOS_COMUNES";
  RentalPaymentLineItemType["WATER"] = "WATER";
  RentalPaymentLineItemType["ELECTRICITY"] = "ELECTRICITY";
  RentalPaymentLineItemType["GAS"] = "GAS";
  RentalPaymentLineItemType["OTHER"] = "OTHER";
  RentalPaymentLineItemType["INSURANCE_PREMIUM"] = "INSURANCE_PREMIUM";
  RentalPaymentLineItemType["INDEXATION_ADJUSTMENT"] = "INDEXATION_ADJUSTMENT";
  RentalPaymentLineItemType["SECURITY_DEPOSIT"] = "SECURITY_DEPOSIT";
  RentalPaymentLineItemType["EXPENSAS"] = "EXPENSAS";
  RentalPaymentLineItemType["BUILDING_EXPENSE"] = "BUILDING_EXPENSE";
})(RentalPaymentLineItemType || (RentalPaymentLineItemType = {}));
/**
 * RentGuaranteeProvider
 * Digital rent guarantee providers.
 */
export var RentGuaranteeProvider;
(function (RentGuaranteeProvider) {
  RentGuaranteeProvider["FINAER"] = "FINAER";
  RentGuaranteeProvider["LOCATIVA"] = "LOCATIVA";
  RentGuaranteeProvider["GARANTIA_YA"] = "GARANTIA_YA";
  RentGuaranteeProvider["AVAL_CHILE"] = "AVAL_CHILE";
  RentGuaranteeProvider["SINGLEKEY"] = "SINGLEKEY";
})(RentGuaranteeProvider || (RentGuaranteeProvider = {}));
/**
 * RentGuaranteeCoverageType
 * Coverage level provided by the guarantee.
 */
export var RentGuaranteeCoverageType;
(function (RentGuaranteeCoverageType) {
  RentGuaranteeCoverageType["RENT_AND_EXPENSES"] = "RENT_AND_EXPENSES";
  RentGuaranteeCoverageType["RENT_ONLY"] = "RENT_ONLY";
  RentGuaranteeCoverageType["FULL_SURETY"] = "FULL_SURETY";
})(RentGuaranteeCoverageType || (RentGuaranteeCoverageType = {}));
/**
 * Properties.PropertyType
 * Property type.
 */
export var PropertiesPropertyType;
(function (PropertiesPropertyType) {
  PropertiesPropertyType["APARTMENT"] = "APARTMENT";
  PropertiesPropertyType["HOUSE"] = "HOUSE";
  PropertiesPropertyType["STUDIO"] = "STUDIO";
  PropertiesPropertyType["CONDO"] = "CONDO";
  PropertiesPropertyType["TOWNHOUSE"] = "TOWNHOUSE";
  PropertiesPropertyType["DUPLEX"] = "DUPLEX";
  PropertiesPropertyType["COMMERCIAL"] = "COMMERCIAL";
  PropertiesPropertyType["LAND"] = "LAND";
  PropertiesPropertyType["LOFT"] = "LOFT";
})(PropertiesPropertyType || (PropertiesPropertyType = {}));
/**
 * Properties.PropertyStatus
 * Property status.
 */
export var PropertiesPropertyStatus;
(function (PropertiesPropertyStatus) {
  PropertiesPropertyStatus["DRAFT"] = "DRAFT";
  PropertiesPropertyStatus["AVAILABLE"] = "AVAILABLE";
  PropertiesPropertyStatus["MAINTENANCE"] = "MAINTENANCE";
  PropertiesPropertyStatus["RENTED"] = "RENTED";
  PropertiesPropertyStatus["INACTIVE"] = "INACTIVE";
})(PropertiesPropertyStatus || (PropertiesPropertyStatus = {}));
/**
 * PropertyAreaType
 * Types of areas within a property.
 */
export var PropertyAreaType;
(function (PropertyAreaType) {
  PropertyAreaType["LIVING_ROOM"] = "LIVING_ROOM";
  PropertyAreaType["BEDROOM"] = "BEDROOM";
  PropertyAreaType["KITCHEN"] = "KITCHEN";
  PropertyAreaType["BATHROOM"] = "BATHROOM";
  PropertyAreaType["DINING_ROOM"] = "DINING_ROOM";
  PropertyAreaType["GARAGE"] = "GARAGE";
  PropertyAreaType["EXTERIOR"] = "EXTERIOR";
  PropertyAreaType["UTILITY_ROOM"] = "UTILITY_ROOM";
  PropertyAreaType["SHARED_SPACE"] = "SHARED_SPACE";
  PropertyAreaType["OTHER"] = "OTHER";
})(PropertyAreaType || (PropertyAreaType = {}));
/**
 * PriorityQueueItemType
 * Schema representing PriorityQueueItemType.
 */
export var PriorityQueueItemType;
(function (PriorityQueueItemType) {
  PriorityQueueItemType["TASK"] = "TASK";
  PriorityQueueItemType["MAINTENANCE"] = "MAINTENANCE";
  PriorityQueueItemType["APPLICATION"] = "APPLICATION";
  PriorityQueueItemType["LEASE"] = "LEASE";
  PriorityQueueItemType["CONTRACT"] = "CONTRACT";
  PriorityQueueItemType["PAYMENT"] = "PAYMENT";
  PriorityQueueItemType["VISIT"] = "VISIT";
  PriorityQueueItemType["SUPPORT"] = "SUPPORT";
})(PriorityQueueItemType || (PriorityQueueItemType = {}));
/**
 * PriorityQueueItemStatus
 * Schema representing PriorityQueueItemStatus.
 */
export var PriorityQueueItemStatus;
(function (PriorityQueueItemStatus) {
  PriorityQueueItemStatus["OPEN"] = "OPEN";
  PriorityQueueItemStatus["IN_PROGRESS"] = "IN_PROGRESS";
  PriorityQueueItemStatus["PENDING_REVIEW"] = "PENDING_REVIEW";
  PriorityQueueItemStatus["RESOLVED"] = "RESOLVED";
  PriorityQueueItemStatus["COMPLETED"] = "COMPLETED";
})(PriorityQueueItemStatus || (PriorityQueueItemStatus = {}));
/**
 * PriorityQueueItemPriority
 * Schema representing PriorityQueueItemPriority.
 */
export var PriorityQueueItemPriority;
(function (PriorityQueueItemPriority) {
  PriorityQueueItemPriority["LOW"] = "LOW";
  PriorityQueueItemPriority["MEDIUM"] = "MEDIUM";
  PriorityQueueItemPriority["HIGH"] = "HIGH";
  PriorityQueueItemPriority["URGENT"] = "URGENT";
  PriorityQueueItemPriority["CRITICAL"] = "CRITICAL";
})(PriorityQueueItemPriority || (PriorityQueueItemPriority = {}));
/**
 * Maintenance.Priority
 * Priority.
 */
export var MaintenancePriority;
(function (MaintenancePriority) {
  MaintenancePriority["LOW"] = "LOW";
  MaintenancePriority["MEDIUM"] = "MEDIUM";
  MaintenancePriority["HIGH"] = "HIGH";
  MaintenancePriority["URGENT"] = "URGENT";
})(MaintenancePriority || (MaintenancePriority = {}));
/**
 * Rentals.PaymentStatus
 * Payment status.
 */
export var RentalsPaymentStatus;
(function (RentalsPaymentStatus) {
  RentalsPaymentStatus["PENDING"] = "PENDING";
  RentalsPaymentStatus["AWAITING_CONFIRMATION"] = "AWAITING_CONFIRMATION";
  RentalsPaymentStatus["CONFIRMED"] = "CONFIRMED";
  RentalsPaymentStatus["LATE"] = "LATE";
  RentalsPaymentStatus["PAID"] = "PAID";
  RentalsPaymentStatus["PARTIALLY_PAID"] = "PARTIALLY_PAID";
})(RentalsPaymentStatus || (RentalsPaymentStatus = {}));
/**
 * Rentals.PayerType
 * Payer type.
 */
export var RentalsPayerType;
(function (RentalsPayerType) {
  RentalsPayerType["OWNER"] = "OWNER";
  RentalsPayerType["TENANT"] = "TENANT";
  RentalsPayerType["UNDECIDED"] = "UNDECIDED";
})(RentalsPayerType || (RentalsPayerType = {}));
/**
 * Core.OrganizationType
 * Organization type.
 */
export var CoreOrganizationType;
(function (CoreOrganizationType) {
  CoreOrganizationType["COMPANY"] = "COMPANY";
  CoreOrganizationType["MANAGER"] = "MANAGER";
  CoreOrganizationType["OWNER_DIRECT"] = "OWNER_DIRECT";
  CoreOrganizationType["PROPERTY_MANAGEMENT"] = "PROPERTY_MANAGEMENT";
  CoreOrganizationType["AGENCY"] = "AGENCY";
  CoreOrganizationType["LANDLORD"] = "LANDLORD";
})(CoreOrganizationType || (CoreOrganizationType = {}));
/**
 * OccupancyStatus
 * Property operational occupancy status.
 */
export var OccupancyStatus;
(function (OccupancyStatus) {
  OccupancyStatus["VACANT"] = "VACANT";
  OccupancyStatus["OCCUPIED"] = "OCCUPIED";
  OccupancyStatus["MAINTENANCE"] = "MAINTENANCE";
  OccupancyStatus["RENOVATION"] = "RENOVATION";
  OccupancyStatus["RESERVED"] = "RESERVED";
  OccupancyStatus["NOTICE_GIVEN"] = "NOTICE_GIVEN";
  OccupancyStatus["VACANT_UNRENTED"] = "VACANT_UNRENTED";
  OccupancyStatus["VACANT_LEASED"] = "VACANT_LEASED";
  OccupancyStatus["UNDER_MAINTENANCE"] = "UNDER_MAINTENANCE";
  OccupancyStatus["OFF_MARKET"] = "OFF_MARKET";
})(OccupancyStatus || (OccupancyStatus = {}));
/**
 * NoteVisibility
 * Who can see the note
 */
export var NoteVisibility;
(function (NoteVisibility) {
  NoteVisibility["INTERNAL"] = "INTERNAL";
  NoteVisibility["TENANT_VISIBLE"] = "TENANT_VISIBLE";
  NoteVisibility["VENDOR_VISIBLE"] = "VENDOR_VISIBLE";
  NoteVisibility["PUBLIC"] = "PUBLIC";
})(NoteVisibility || (NoteVisibility = {}));
/**
 * NoteType
 * Types of notes that can be created
 */
export var NoteType;
(function (NoteType) {
  NoteType["MANAGER"] = "MANAGER";
  NoteType["INSPECTION"] = "INSPECTION";
  NoteType["COMPLETION"] = "COMPLETION";
  NoteType["REVIEW"] = "REVIEW";
  NoteType["INTERNAL"] = "INTERNAL";
  NoteType["GENERAL"] = "GENERAL";
})(NoteType || (NoteType = {}));
/**
 * NoteEntityType
 * Entity types that can have notes attached
 */
export var NoteEntityType;
(function (NoteEntityType) {
  NoteEntityType["APPLICATION"] = "APPLICATION";
  NoteEntityType["PROPERTY"] = "PROPERTY";
  NoteEntityType["RENTAL"] = "RENTAL";
  NoteEntityType["MOVE_IN"] = "MOVE_IN";
  NoteEntityType["MAINTENANCE_PROJECT"] = "MAINTENANCE_PROJECT";
  NoteEntityType["MAINTENANCE_LINE_ITEM"] = "MAINTENANCE_LINE_ITEM";
  NoteEntityType["MAINTENANCE_REQUEST"] = "MAINTENANCE_REQUEST";
  NoteEntityType["MAINTENANCE_QUOTE"] = "MAINTENANCE_QUOTE";
  NoteEntityType["MAINTENANCE_STATEMENT"] = "MAINTENANCE_STATEMENT";
  NoteEntityType["WORK_ORDER"] = "WORK_ORDER";
  NoteEntityType["ISSUE"] = "ISSUE";
  NoteEntityType["ORGANIZATION"] = "ORGANIZATION";
  NoteEntityType["USER"] = "USER";
  NoteEntityType["TASK"] = "TASK";
  NoteEntityType["AUDIT_LOG"] = "AUDIT_LOG";
  NoteEntityType["ACTIVITY"] = "ACTIVITY";
})(NoteEntityType || (NoteEntityType = {}));
/**
 * MoveOutStatus
 * Move out status.
 */
export var MoveOutStatus;
(function (MoveOutStatus) {
  MoveOutStatus["SCHEDULED"] = "SCHEDULED";
  MoveOutStatus["COMPLETED"] = "COMPLETED";
  MoveOutStatus["CANCELLED"] = "CANCELLED";
})(MoveOutStatus || (MoveOutStatus = {}));
/**
 * Rentals.MoveInStatus
 * Move in status.
 */
export var RentalsMoveInStatus;
(function (RentalsMoveInStatus) {
  RentalsMoveInStatus["SCHEDULED"] = "SCHEDULED";
  RentalsMoveInStatus["COMPLETED"] = "COMPLETED";
  RentalsMoveInStatus["CANCELLED"] = "CANCELLED";
})(RentalsMoveInStatus || (RentalsMoveInStatus = {}));
/**
 * MoveInDocumentType
 * Supported document types for move-in uploads.
 */
export var MoveInDocumentType;
(function (MoveInDocumentType) {
  MoveInDocumentType["INSPECTION_REPORT"] = "INSPECTION_REPORT";
  MoveInDocumentType["METER_PHOTO"] = "METER_PHOTO";
  MoveInDocumentType["KEY_RECEIPT"] = "KEY_RECEIPT";
})(MoveInDocumentType || (MoveInDocumentType = {}));
/**
 * MaintenanceStatementStatus
 * Maintenance statement status.
 */
export var MaintenanceStatementStatus;
(function (MaintenanceStatementStatus) {
  MaintenanceStatementStatus["DRAFT"] = "DRAFT";
  MaintenanceStatementStatus["SUBMITTED"] = "SUBMITTED";
  MaintenanceStatementStatus["APPROVED"] = "APPROVED";
  MaintenanceStatementStatus["DISPUTED"] = "DISPUTED";
  MaintenanceStatementStatus["PAID"] = "PAID";
})(MaintenanceStatementStatus || (MaintenanceStatementStatus = {}));
/**
 * Maintenance.MaintenanceRequestStatus
 * Lifecycle for maintenance requests (reactive, planned, template, occurrence).
 */
export var MaintenanceMaintenanceRequestStatus;
(function (MaintenanceMaintenanceRequestStatus) {
  MaintenanceMaintenanceRequestStatus["OPEN"] = "OPEN";
  MaintenanceMaintenanceRequestStatus["ASSIGNED"] = "ASSIGNED";
  MaintenanceMaintenanceRequestStatus["IN_PROGRESS"] = "IN_PROGRESS";
  MaintenanceMaintenanceRequestStatus["COMPLETED"] = "COMPLETED";
  MaintenanceMaintenanceRequestStatus["CLOSED"] = "CLOSED";
  MaintenanceMaintenanceRequestStatus["ACTIVE"] = "ACTIVE";
  MaintenanceMaintenanceRequestStatus["PAUSED"] = "PAUSED";
  MaintenanceMaintenanceRequestStatus["CANCELLED"] = "CANCELLED";
  MaintenanceMaintenanceRequestStatus["SCHEDULED"] = "SCHEDULED";
  MaintenanceMaintenanceRequestStatus["SKIPPED"] = "SKIPPED";
})(
  MaintenanceMaintenanceRequestStatus ||
    (MaintenanceMaintenanceRequestStatus = {}),
);
/**
 * MaintenanceRequestKind
 * Maintenance request kind.
 */
export var MaintenanceRequestKind;
(function (MaintenanceRequestKind) {
  MaintenanceRequestKind["REACTIVE"] = "REACTIVE";
  MaintenanceRequestKind["PLANNED_ONE_TIME"] = "PLANNED_ONE_TIME";
  MaintenanceRequestKind["RECURRING_TEMPLATE"] = "RECURRING_TEMPLATE";
  MaintenanceRequestKind["OCCURRENCE"] = "OCCURRENCE";
})(MaintenanceRequestKind || (MaintenanceRequestKind = {}));
/**
 * MaintenanceQuoteStatus
 * Maintenance quote status.
 */
export var MaintenanceQuoteStatus;
(function (MaintenanceQuoteStatus) {
  MaintenanceQuoteStatus["REQUESTED"] = "REQUESTED";
  MaintenanceQuoteStatus["DRAFT"] = "DRAFT";
  MaintenanceQuoteStatus["SUBMITTED"] = "SUBMITTED";
  MaintenanceQuoteStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
  MaintenanceQuoteStatus["ACCEPTED"] = "ACCEPTED";
  MaintenanceQuoteStatus["REJECTED"] = "REJECTED";
  MaintenanceQuoteStatus["NEEDS_CLARIFICATION"] = "NEEDS_CLARIFICATION";
  MaintenanceQuoteStatus["EXPIRED"] = "EXPIRED";
})(MaintenanceQuoteStatus || (MaintenanceQuoteStatus = {}));
/**
 * MaintenanceProjectStatus
 * Maintenance project status.
 */
export var MaintenanceProjectStatus;
(function (MaintenanceProjectStatus) {
  MaintenanceProjectStatus["DRAFT"] = "DRAFT";
  MaintenanceProjectStatus["ACTIVE"] = "ACTIVE";
  MaintenanceProjectStatus["IN_PROGRESS"] = "IN_PROGRESS";
  MaintenanceProjectStatus["PENDING_REVIEW"] = "PENDING_REVIEW";
  MaintenanceProjectStatus["COMPLETED"] = "COMPLETED";
  MaintenanceProjectStatus["ON_HOLD"] = "ON_HOLD";
  MaintenanceProjectStatus["CANCELLED"] = "CANCELLED";
})(MaintenanceProjectStatus || (MaintenanceProjectStatus = {}));
/**
 * MaintenanceProjectSectionType
 * How a section groups work (see maintenance project specs).
 */
export var MaintenanceProjectSectionType;
(function (MaintenanceProjectSectionType) {
  MaintenanceProjectSectionType["GLOBAL"] = "GLOBAL";
  MaintenanceProjectSectionType["AREA"] = "AREA";
  MaintenanceProjectSectionType["TRADE"] = "TRADE";
  MaintenanceProjectSectionType["PHASE"] = "PHASE";
})(MaintenanceProjectSectionType || (MaintenanceProjectSectionType = {}));
/**
 * MaintenanceProjectMilestoneStatus
 * Maintenance project milestone status.
 */
export var MaintenanceProjectMilestoneStatus;
(function (MaintenanceProjectMilestoneStatus) {
  MaintenanceProjectMilestoneStatus["PLANNED"] = "PLANNED";
  MaintenanceProjectMilestoneStatus["IN_PROGRESS"] = "IN_PROGRESS";
  MaintenanceProjectMilestoneStatus["DONE"] = "DONE";
  MaintenanceProjectMilestoneStatus["BLOCKED"] = "BLOCKED";
})(
  MaintenanceProjectMilestoneStatus || (MaintenanceProjectMilestoneStatus = {}),
);
/**
 * MaintenanceLineItemStatus
 * Maintenance line item status.
 */
export var MaintenanceLineItemStatus;
(function (MaintenanceLineItemStatus) {
  MaintenanceLineItemStatus["OPEN"] = "OPEN";
  MaintenanceLineItemStatus["IN_PROGRESS"] = "IN_PROGRESS";
  MaintenanceLineItemStatus["PENDING_APPROVAL"] = "PENDING_APPROVAL";
  MaintenanceLineItemStatus["APPROVED"] = "APPROVED";
  MaintenanceLineItemStatus["NEEDS_REWORK"] = "NEEDS_REWORK";
  MaintenanceLineItemStatus["DONE"] = "DONE";
  MaintenanceLineItemStatus["CANCELLED"] = "CANCELLED";
})(MaintenanceLineItemStatus || (MaintenanceLineItemStatus = {}));
/**
 * MaintenanceLineItemCategory
 * Maintenance line item category.
 */
export var MaintenanceLineItemCategory;
(function (MaintenanceLineItemCategory) {
  MaintenanceLineItemCategory["PLUMBING"] = "PLUMBING";
  MaintenanceLineItemCategory["ELECTRICAL"] = "ELECTRICAL";
  MaintenanceLineItemCategory["HVAC"] = "HVAC";
  MaintenanceLineItemCategory["APPLIANCES"] = "APPLIANCES";
  MaintenanceLineItemCategory["STRUCTURAL"] = "STRUCTURAL";
  MaintenanceLineItemCategory["PAINTING"] = "PAINTING";
  MaintenanceLineItemCategory["CLEANING"] = "CLEANING";
  MaintenanceLineItemCategory["LANDSCAPING"] = "LANDSCAPING";
  MaintenanceLineItemCategory["CARPENTRY"] = "CARPENTRY";
  MaintenanceLineItemCategory["FEE"] = "FEE";
  MaintenanceLineItemCategory["OTHER"] = "OTHER";
})(MaintenanceLineItemCategory || (MaintenanceLineItemCategory = {}));
/**
 * MaintenanceLineItemAssigneeType
 * Maintenance line item assignee type.
 */
export var MaintenanceLineItemAssigneeType;
(function (MaintenanceLineItemAssigneeType) {
  MaintenanceLineItemAssigneeType["USER"] = "USER";
  MaintenanceLineItemAssigneeType["VENDOR"] = "VENDOR";
})(MaintenanceLineItemAssigneeType || (MaintenanceLineItemAssigneeType = {}));
/**
 * MaintenanceEvaluationResponseType
 * How an evaluation question response is captured (see maintenance project specs).
 */
export var MaintenanceEvaluationResponseType;
(function (MaintenanceEvaluationResponseType) {
  MaintenanceEvaluationResponseType["BOOLEAN"] = "BOOLEAN";
  MaintenanceEvaluationResponseType["SELECT"] = "SELECT";
  MaintenanceEvaluationResponseType["TEXT"] = "TEXT";
  MaintenanceEvaluationResponseType["NUMBER"] = "NUMBER";
})(
  MaintenanceEvaluationResponseType || (MaintenanceEvaluationResponseType = {}),
);
/**
 * MaintenanceEvaluationQuestionStatus
 * Lifecycle of an evaluation question instance on a section.
 */
export var MaintenanceEvaluationQuestionStatus;
(function (MaintenanceEvaluationQuestionStatus) {
  MaintenanceEvaluationQuestionStatus["PENDING"] = "PENDING";
  MaintenanceEvaluationQuestionStatus["ANSWERED"] = "ANSWERED";
  MaintenanceEvaluationQuestionStatus["SKIPPED"] = "SKIPPED";
  MaintenanceEvaluationQuestionStatus["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(
  MaintenanceEvaluationQuestionStatus ||
    (MaintenanceEvaluationQuestionStatus = {}),
);
/**
 * Maintenance.MaintenanceCategory
 * Maintenance category.
 */
export var MaintenanceMaintenanceCategory;
(function (MaintenanceMaintenanceCategory) {
  MaintenanceMaintenanceCategory["PLUMBING"] = "PLUMBING";
  MaintenanceMaintenanceCategory["ELECTRICAL"] = "ELECTRICAL";
  MaintenanceMaintenanceCategory["HVAC"] = "HVAC";
  MaintenanceMaintenanceCategory["APPLIANCE"] = "APPLIANCE";
  MaintenanceMaintenanceCategory["STRUCTURAL"] = "STRUCTURAL";
  MaintenanceMaintenanceCategory["CLEANING"] = "CLEANING";
  MaintenanceMaintenanceCategory["LANDSCAPING"] = "LANDSCAPING";
  MaintenanceMaintenanceCategory["ELEVATOR"] = "ELEVATOR";
  MaintenanceMaintenanceCategory["OTHER"] = "OTHER";
})(MaintenanceMaintenanceCategory || (MaintenanceMaintenanceCategory = {}));
/**
 * ListingType
 * Listing type.
 */
export var ListingType;
(function (ListingType) {
  ListingType["RENT"] = "RENT";
  ListingType["SALE"] = "SALE";
})(ListingType || (ListingType = {}));
/**
 * Listings.ListingStatus
 * Listing status.
 */
export var ListingsListingStatus;
(function (ListingsListingStatus) {
  ListingsListingStatus["DRAFT"] = "DRAFT";
  ListingsListingStatus["PUBLISHED"] = "PUBLISHED";
  ListingsListingStatus["ACTIVE"] = "ACTIVE";
  ListingsListingStatus["PAUSED"] = "PAUSED";
  ListingsListingStatus["RENTED"] = "RENTED";
  ListingsListingStatus["EXPIRED"] = "EXPIRED";
  ListingsListingStatus["ARCHIVED"] = "ARCHIVED";
})(ListingsListingStatus || (ListingsListingStatus = {}));
/**
 * Core.IssueType
 * Issue type.
 */
export var CoreIssueType;
(function (CoreIssueType) {
  CoreIssueType["VISIT"] = "VISIT";
  CoreIssueType["TASK"] = "TASK";
  CoreIssueType["MAINTENANCE"] = "MAINTENANCE";
  CoreIssueType["APPLICATION_REVIEW"] = "APPLICATION_REVIEW";
  CoreIssueType["PAYMENT_DUE"] = "PAYMENT_DUE";
  CoreIssueType["CONTRACT_REVIEW"] = "CONTRACT_REVIEW";
  CoreIssueType["DOCUMENT_UPLOAD"] = "DOCUMENT_UPLOAD";
  CoreIssueType["MOVE_IN"] = "MOVE_IN";
  CoreIssueType["MOVE_OUT"] = "MOVE_OUT";
})(CoreIssueType || (CoreIssueType = {}));
/**
 * Core.IssueStatus
 * Issue status.
 */
export var CoreIssueStatus;
(function (CoreIssueStatus) {
  CoreIssueStatus["PENDING"] = "PENDING";
  CoreIssueStatus["IN_PROGRESS"] = "IN_PROGRESS";
  CoreIssueStatus["WAITING"] = "WAITING";
  CoreIssueStatus["COMPLETED"] = "COMPLETED";
  CoreIssueStatus["CLOSED"] = "CLOSED";
  CoreIssueStatus["CANCELLED"] = "CANCELLED";
})(CoreIssueStatus || (CoreIssueStatus = {}));
/**
 * InformationRequestType
 * Information request type.
 */
export var InformationRequestType;
(function (InformationRequestType) {
  InformationRequestType["FORM"] = "FORM";
  InformationRequestType["DOCUMENT"] = "DOCUMENT";
  InformationRequestType["FREETEXT"] = "FREETEXT";
})(InformationRequestType || (InformationRequestType = {}));
/**
 * InformationRequestStatus
 * Information request status.
 */
export var InformationRequestStatus;
(function (InformationRequestStatus) {
  InformationRequestStatus["PENDING"] = "PENDING";
  InformationRequestStatus["SUBMITTED"] = "SUBMITTED";
  InformationRequestStatus["ACCEPTED"] = "ACCEPTED";
  InformationRequestStatus["RETURNED"] = "RETURNED";
})(InformationRequestStatus || (InformationRequestStatus = {}));
/**
 * FormSubmissionStatus
 * Form submission status.
 */
export var FormSubmissionStatus;
(function (FormSubmissionStatus) {
  FormSubmissionStatus["DRAFT"] = "DRAFT";
  FormSubmissionStatus["SUBMITTED"] = "SUBMITTED";
  FormSubmissionStatus["ACCEPTED"] = "ACCEPTED";
  FormSubmissionStatus["RETURNED"] = "RETURNED";
})(FormSubmissionStatus || (FormSubmissionStatus = {}));
/**
 * FieldMeasurementAssessment
 * Field measurement status/assessment.
 */
export var FieldMeasurementAssessment;
(function (FieldMeasurementAssessment) {
  FieldMeasurementAssessment["NOMINAL"] = "NOMINAL";
  FieldMeasurementAssessment["WARNING"] = "WARNING";
  FieldMeasurementAssessment["CRITICAL"] = "CRITICAL";
})(FieldMeasurementAssessment || (FieldMeasurementAssessment = {}));
/**
 * Listings.ExploreSort
 * Result ordering. ``newest`` = ``published_at DESC NULLS LAST``.
 */
export var ListingsExploreSort;
(function (ListingsExploreSort) {
  ListingsExploreSort["Newest"] = "newest";
  ListingsExploreSort["PriceAsc"] = "price_asc";
  ListingsExploreSort["PriceDesc"] = "price_desc";
})(ListingsExploreSort || (ListingsExploreSort = {}));
/**
 * Listings.ExploreMode
 * Marketplace mode. Maps to ``ListingType`` via ``listing_type_for_mode``.
 */
export var ListingsExploreMode;
(function (ListingsExploreMode) {
  ListingsExploreMode["Rent"] = "rent";
  ListingsExploreMode["Buy"] = "buy";
})(ListingsExploreMode || (ListingsExploreMode = {}));
/**
 * DepositType
 * Schema representing DepositType.
 */
export var DepositType;
(function (DepositType) {
  DepositType["SECURITY_DEPOSIT"] = "SECURITY_DEPOSIT";
  DepositType["PET_DEPOSIT"] = "PET_DEPOSIT";
  DepositType["KEY_DEPOSIT"] = "KEY_DEPOSIT";
  DepositType["LAST_MONTH_RENT"] = "LAST_MONTH_RENT";
  DepositType["HOLDING_DEPOSIT"] = "HOLDING_DEPOSIT";
})(DepositType || (DepositType = {}));
/**
 * DepositStatus
 * Schema representing DepositStatus.
 */
export var DepositStatus;
(function (DepositStatus) {
  DepositStatus["HELD"] = "HELD";
  DepositStatus["DEDUCTION_PENDING"] = "DEDUCTION_PENDING";
  DepositStatus["DISPUTED"] = "DISPUTED";
  DepositStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
  DepositStatus["REFUNDED"] = "REFUNDED";
  DepositStatus["FORFEITED"] = "FORFEITED";
})(DepositStatus || (DepositStatus = {}));
/**
 * DepositRecordStatus
 * Schema representing DepositRecordStatus.
 */
export var DepositRecordStatus;
(function (DepositRecordStatus) {
  DepositRecordStatus["HELD"] = "HELD";
  DepositRecordStatus["ACCRUING_INTEREST"] = "ACCRUING_INTEREST";
  DepositRecordStatus["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
  DepositRecordStatus["REFUNDED"] = "REFUNDED";
  DepositRecordStatus["FORFEITED"] = "FORFEITED";
})(DepositRecordStatus || (DepositRecordStatus = {}));
/**
 * DeductionCategory
 * Schema representing DeductionCategory.
 */
export var DeductionCategory;
(function (DeductionCategory) {
  DeductionCategory["CLEANING"] = "CLEANING";
  DeductionCategory["REPAIRS"] = "REPAIRS";
  DeductionCategory["UNPAID_RENT"] = "UNPAID_RENT";
  DeductionCategory["UTILITIES"] = "UTILITIES";
  DeductionCategory["KEY_REPLACEMENT"] = "KEY_REPLACEMENT";
  DeductionCategory["OTHER"] = "OTHER";
})(DeductionCategory || (DeductionCategory = {}));
/**
 * DatabaseUsageMode
 * Database usage mode.
 */
export var DatabaseUsageMode;
(function (DatabaseUsageMode) {
  DatabaseUsageMode["GENERAL"] = "GENERAL";
  DatabaseUsageMode["APPLICATION_INTAKE"] = "APPLICATION_INTAKE";
  DatabaseUsageMode["INFORMATION_REQUEST"] = "INFORMATION_REQUEST";
})(DatabaseUsageMode || (DatabaseUsageMode = {}));
/**
 * Core.Currency
 * Currency.
 */
export var CoreCurrency;
(function (CoreCurrency) {
  CoreCurrency["CLP"] = "CLP";
  CoreCurrency["UF"] = "UF";
  CoreCurrency["ARS"] = "ARS";
  CoreCurrency["USD"] = "USD";
  CoreCurrency["CAD"] = "CAD";
  CoreCurrency["EUR"] = "EUR";
})(CoreCurrency || (CoreCurrency = {}));
/**
 * CoordinationMode
 * Coordination mode.
 */
export var CoordinationMode;
(function (CoordinationMode) {
  CoordinationMode["SELF_MANAGED"] = "SELF_MANAGED";
  CoordinationMode["CO_MANAGED"] = "CO_MANAGED";
  CoordinationMode["FULLY_MANAGED"] = "FULLY_MANAGED";
  CoordinationMode["DIRECT"] = "DIRECT";
  CoordinationMode["ASSISTED"] = "ASSISTED";
  CoordinationMode["HYBRID"] = "HYBRID";
})(CoordinationMode || (CoordinationMode = {}));
/**
 * Rentals.ContractStatus
 * Contract status.
 */
export var RentalsContractStatus;
(function (RentalsContractStatus) {
  RentalsContractStatus["DRAFT"] = "DRAFT";
  RentalsContractStatus["NEGOTIATING"] = "NEGOTIATING";
  RentalsContractStatus["PENDING_SIGNATURE"] = "PENDING_SIGNATURE";
  RentalsContractStatus["ACTIVE"] = "ACTIVE";
  RentalsContractStatus["NOTARIZED"] = "NOTARIZED";
  RentalsContractStatus["EXPIRED"] = "EXPIRED";
  RentalsContractStatus["TERMINATED"] = "TERMINATED";
})(RentalsContractStatus || (RentalsContractStatus = {}));
/**
 * CaseStatus
 * Schema representing CaseStatus.
 */
export var CaseStatus;
(function (CaseStatus) {
  CaseStatus["NEW"] = "NEW";
  CaseStatus["OPEN"] = "OPEN";
  CaseStatus["IN_PROGRESS"] = "IN_PROGRESS";
  CaseStatus["WAITING_CUSTOMER"] = "WAITING_CUSTOMER";
  CaseStatus["RESOLVED"] = "RESOLVED";
  CaseStatus["CLOSED"] = "CLOSED";
})(CaseStatus || (CaseStatus = {}));
/**
 * CaseScope
 * Schema representing CaseScope.
 */
export var CaseScope;
(function (CaseScope) {
  CaseScope["ORGANIZATION"] = "ORGANIZATION";
  CaseScope["PLATFORM"] = "PLATFORM";
})(CaseScope || (CaseScope = {}));
/**
 * Calendar.CalendarEventType
 * Schema representing Calendar.CalendarEventType.
 */
export var CalendarCalendarEventType;
(function (CalendarCalendarEventType) {
  CalendarCalendarEventType["PROPERTY_VISIT"] = "PROPERTY_VISIT";
  CalendarCalendarEventType["MAINTENANCE_VISIT"] = "MAINTENANCE_VISIT";
  CalendarCalendarEventType["SELF_GUIDED_TOUR"] = "SELF_GUIDED_TOUR";
  CalendarCalendarEventType["TASK_DEADLINE"] = "TASK_DEADLINE";
  CalendarCalendarEventType["GENERAL"] = "GENERAL";
  CalendarCalendarEventType["INSPECTION"] = "INSPECTION";
  CalendarCalendarEventType["LEASE_EVENT"] = "LEASE_EVENT";
})(CalendarCalendarEventType || (CalendarCalendarEventType = {}));
/**
 * BureauProvider
 * Credit and financial bureau scoring providers.
 */
export var BureauProvider;
(function (BureauProvider) {
  BureauProvider["NOSIS_VERAZ_AR"] = "NOSIS_VERAZ_AR";
  BureauProvider["DICOM_EQUIFAX_CL"] = "DICOM_EQUIFAX_CL";
  BureauProvider["EQUIFAX_CA"] = "EQUIFAX_CA";
})(BureauProvider || (BureauProvider = {}));
/**
 * Calendar.BookingStatus
 * Schema representing Calendar.BookingStatus.
 */
export var CalendarBookingStatus;
(function (CalendarBookingStatus) {
  CalendarBookingStatus["PENDING"] = "PENDING";
  CalendarBookingStatus["CONFIRMED"] = "CONFIRMED";
  CalendarBookingStatus["COMPLETED"] = "COMPLETED";
  CalendarBookingStatus["DECLINED"] = "DECLINED";
  CalendarBookingStatus["CANCELLED"] = "CANCELLED";
  CalendarBookingStatus["NO_SHOW"] = "NO_SHOW";
})(CalendarBookingStatus || (CalendarBookingStatus = {}));
/**
 * ApprovalStrategy
 * Schema representing ApprovalStrategy.
 */
export var ApprovalStrategy;
(function (ApprovalStrategy) {
  ApprovalStrategy["SINGLE"] = "SINGLE";
  ApprovalStrategy["ANY_OF"] = "ANY_OF";
  ApprovalStrategy["ALL_OF"] = "ALL_OF";
  ApprovalStrategy["SEQUENTIAL"] = "SEQUENTIAL";
})(ApprovalStrategy || (ApprovalStrategy = {}));
/**
 * Applications.ApplicationStatus
 * Application status.
 */
export var ApplicationsApplicationStatus;
(function (ApplicationsApplicationStatus) {
  ApplicationsApplicationStatus["DRAFT"] = "DRAFT";
  ApplicationsApplicationStatus["SUBMITTED"] = "SUBMITTED";
  ApplicationsApplicationStatus["UNDER_REVIEW"] = "UNDER_REVIEW";
  ApplicationsApplicationStatus["PROFILE_SCREENING"] = "PROFILE_SCREENING";
  ApplicationsApplicationStatus["APPROVED"] = "APPROVED";
  ApplicationsApplicationStatus["REJECTED"] = "REJECTED";
  ApplicationsApplicationStatus["BACKUP"] = "BACKUP";
  ApplicationsApplicationStatus["CONTRACT_PROPOSED"] = "CONTRACT_PROPOSED";
  ApplicationsApplicationStatus["CONTRACT_SIGNED"] = "CONTRACT_SIGNED";
  ApplicationsApplicationStatus["WITHDRAWN"] = "WITHDRAWN";
})(ApplicationsApplicationStatus || (ApplicationsApplicationStatus = {}));
/**
 * Core.AdjustmentIndex
 * Adjustment index.
 */
export var CoreAdjustmentIndex;
(function (CoreAdjustmentIndex) {
  CoreAdjustmentIndex["UF"] = "UF";
  CoreAdjustmentIndex["IPC_CL"] = "IPC_CL";
  CoreAdjustmentIndex["ICL"] = "ICL";
  CoreAdjustmentIndex["IPC_AR"] = "IPC_AR";
  CoreAdjustmentIndex["DOLAR_BLUE"] = "DOLAR_BLUE";
  CoreAdjustmentIndex["DOLAR_MEP"] = "DOLAR_MEP";
  CoreAdjustmentIndex["DOLAR_OFICIAL"] = "DOLAR_OFICIAL";
  CoreAdjustmentIndex["NONE"] = "NONE";
})(CoreAdjustmentIndex || (CoreAdjustmentIndex = {}));


export var Applications = {
  ApplicationStatus: ApplicationsApplicationStatus,
};

export var Calendar = {
  CalendarEventType: CalendarCalendarEventType,
  BookingStatus: CalendarBookingStatus,
};

export var Core = {
  FieldMeasurementAssessment: FieldMeasurementAssessment,
  RentalPaymentLineItemType: RentalPaymentLineItemType,
  RentGuaranteeCoverageType: RentGuaranteeCoverageType,
  PriorityQueueItemPriority: PriorityQueueItemPriority,
  InformationRequestStatus: InformationRequestStatus,
  ShareLinkPermission: CoreShareLinkPermission,
  PriorityQueueItemStatus: PriorityQueueItemStatus,
  TourVerificationStatus: TourVerificationStatus,
  InformationRequestType: InformationRequestType,
  ShareResourceType: CoreShareResourceType,
  RentGuaranteeProvider: RentGuaranteeProvider,
  PriorityQueueItemType: PriorityQueueItemType,
  OrganizationType: CoreOrganizationType,
  FormSubmissionStatus: FormSubmissionStatus,
  TaxComplianceStatus: TaxComplianceStatus,
  SmartLockDeviceType: SmartLockDeviceType,
  SmartLockAccessMode: SmartLockAccessMode,
  DepositRecordStatus: DepositRecordStatus,
  AdjustmentIndex: CoreAdjustmentIndex,
  MoveInDocumentType: MoveInDocumentType,
  SmartLockProvider: SmartLockProvider,
  DeductionCategory: DeductionCategory,
  DatabaseUsageMode: DatabaseUsageMode,
  TrustAccountType: TrustAccountType,
  TourAccessStatus: TourAccessStatus,
  PropertyAreaType: PropertyAreaType,
  CoordinationMode: CoordinationMode,
  ApprovalStrategy: ApprovalStrategy,
  TaxDocumentType: TaxDocumentType,
  SmartLockStatus: SmartLockStatus,
  OccupancyStatus: OccupancyStatus,
  IssueStatus: CoreIssueStatus,
  NoteVisibility: NoteVisibility,
  NoteEntityType: NoteEntityType,
  BureauProvider: BureauProvider,
  MoveOutStatus: MoveOutStatus,
  IssueType: CoreIssueType,
  DepositStatus: DepositStatus,
  UserRole: CoreUserRole,
  UploadStatus: UploadStatus,
  TaskPriority: TaskPriority,
  Currency: CoreCurrency,
  ListingType: ListingType,
  DepositType: DepositType,
  TaskStatus: TaskStatus,
  CaseStatus: CaseStatus,
  TaxStatus: TaxStatus,
  RiskGrade: RiskGrade,
  CaseScope: CaseScope,
  NoteType: NoteType,
};

export var Listings = {
  ListingStatus: ListingsListingStatus,
  ExploreSort: ListingsExploreSort,
  ExploreMode: ListingsExploreMode,
};

export var Maintenance = {
  MaintenanceRequestStatus: MaintenanceMaintenanceRequestStatus,
  EvaluationQuestionStatus: MaintenanceEvaluationQuestionStatus,
  ProjectMilestoneStatus: MaintenanceProjectMilestoneStatus,
  EvaluationResponseType: MaintenanceEvaluationResponseType,
  LineItemAssigneeType: MaintenanceLineItemAssigneeType,
  MaintenanceCategory: MaintenanceMaintenanceCategory,
  ProjectSectionType: MaintenanceProjectSectionType,
  LineItemCategory: MaintenanceLineItemCategory,
  StatementStatus: MaintenanceStatementStatus,
  LineItemStatus: MaintenanceLineItemStatus,
  ProjectStatus: MaintenanceProjectStatus,
  RequestKind: MaintenanceRequestKind,
  QuoteStatus: MaintenanceQuoteStatus,
  Priority: MaintenancePriority,
};

export var Properties = {
  PropertyStatus: PropertiesPropertyStatus,
  PropertyType: PropertiesPropertyType,
};

export var Rentals = {
  ContractStatus: RentalsContractStatus,
  PaymentStatus: RentalsPaymentStatus,
  RentalStatus: RentalsRentalStatus,
  MoveInStatus: RentalsMoveInStatus,
  PayerType: RentalsPayerType,
};

